export default __webpack_public_path__ + "static/media/GF Piping Systems.331ab5ff.png";